module.exports = __webpack_public_path__ + "static/media/grayscale.2b0ea539.jpg";